<template>
  <div class="recharge-container">
    <div class="header">
      <img class="header-bg" src="@/assets/2025/freeBg.png" />
      <p class="header-title">{{ theme }}</p>
    </div>

    <div class="center-title">
      <p>{{ description }}</p>
    </div>

    <!-- 非免费领取的才显示提示 -->
    <div class="center-tip" v-if="enterType !== '2'">
      <p>缴纳押金后立即生效，畅享无忧上网体验。</p>
    </div>

    <div class="bottom-content">
      <div class="payment-content">
        <p v-if="agreementList.length" class="payment-infor">
          {{ enterType === "2" ? "领取" : "支付" }}即同意
          <span class="mainC" @click="goToAgreement(0)"
            >《{{ agreementList[0].name }}》</span
          >

          <template v-if="agreementList.length > 1">
            与
            <span class="mainC" @click="goToAgreement(1)">
              《{{ agreementList[1].name }}》
            </span>
          </template>

          <template v-if="agreementList.length > 2">
            与
            <span class="mainC" @click="goToAgreement(2)">
              《{{ agreementList[2].name }}》
            </span>
          </template>
        </p>
      </div>

      <!-- 免费领取样式 -->
      <div v-if="enterType === '2'" class="footer-content">
        <button class="payment-button" @click="finshPayAction">立即领取</button>
      </div>

      <!-- 押金支付样式 -->
      <div v-else class="footer-content-2">
        <p class="footer-content-price">
          总计：<span class="mainC"
            >¥<span class="price-amount">{{ depositAmount }}</span></span
          >
        </p>
        <button class="payment-button-2" @click="finshPayAction">
          立即支付
        </button>
      </div>
    </div>

    <van-popup
      v-model="xyShow"
      position="bottom"
      round
      safe-area-inset-bottom
      :style="{ height: '70%' }"
    >
      <!-- 固定头部 -->
      <div class="xy-content">
        <div class="xy-title">押金说明</div>
        <div class="xy-right">
          <img class="xy-icon" src="@/assets/tip.png" />请滑到底部
        </div>
      </div>

      <!-- 滚动区域 -->
      <div class="xy-body">
        <iframe ref="iframeRef" :src="xyUrl" class="xy-iframe"></iframe>
      </div>

      <!-- 固定底部按钮 -->
      <div class="xy-foot">
        <div class="xy-cancel" @click="xyShow = false">取消</div>
        <div
          class="xy-ok"
          :class="{ disabled: countdown > 0 }"
          @click="handleAgree"
        >
          同意并支付<span v-if="countdown > 0">({{ countdown }}s)</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { createFreeOrder, createDepositOrder, getAgreement } from "@/api/home";
import { Toast } from "vant";
import { Dialog } from "vant";
export default {
  data() {
    return {
      sn: "",
      agreementList: [],
      enterType: "",
      description: "", //描述
      theme: "", //主题
      depositAmount: "", //缴纳押金(元)
      terminalId: "", //设备ID
      xyShow: false,
      xyUrl: "",
      countdown: 10,
      phone:""
    };
  },
  mounted() {
    this.phone = this.$route.query.phone;
    this.sn = this.$route.query.sn;
    this.description = this.$route.query.description;
    this.theme = this.$route.query.theme;
    this.enterType = this.$route.query.enterType;
    this.depositAmount = this.$route.query.depositAmount;
    this.terminalId = this.$route.query.terminalId;
    this.requestAgreementAction();
  },
  methods: {
    requestAgreementAction() {
      let array = [3];
      if (this.enterType == 3) {
        array = [1, 3, 4];
        this.requestXyAction();
      }

      getAgreement({
        appType: "U",
        protocolTypes: array,
      }).then((res) => {
        this.agreementList = res.map((item) => {
          return {
            name: item.name,
            url: item.url,
          };
        });
      });
    },

    ///获取押金协议说明
    requestXyAction() {
      getAgreement({
        appType: "U",
        protocolTypes: [4],
      }).then((res) => {
        let xyArr = res.map((item) => {
          return {
            name: item.name,
            url: item.url,
          };
        });
        this.xyUrl = xyArr.length > 0 ? xyArr[0].url : null;
      });
    },

    goToAgreement(index) {
      if (this.agreementList[index] && this.agreementList[index].url) {
        window.location.href = this.agreementList[index].url;
      } else {
        Toast.fail("协议链接无效");
      }
    },

    ///下单
    finshPayAction() {
      if (this.enterType === "2") {
        const loadingToast = Toast.loading({
          message: "领取中...",
          forbidClick: true,
          duration: 0,
        });

        createFreeOrder({
          terminalId: this.terminalId,
          phone:this.phone
        }).then((res) => {
          loadingToast.clear();
          Toast.success({
            message: "领取成功",
            duration: 1200,
          });
          // 成功提示结束后再跳转
          setTimeout(() => {
            this.$store.dispatch("updateDeviceID", this.terminalId);
            this.uni.navigateTo("/home/auth?sn=" + this.sn + "&isFirst=1");
          }, 1200);
        });
      } else {
        // 弹押金协议
        this.xyShow = true;
        const timer = setInterval(() => {
          this.countdown--;
          if (this.countdown <= 0) {
            clearInterval(timer);
          }
        }, 1000);
      }
    },

    ///同意按钮
    handleAgree() {
      if (this.countdown > 0) {
        return;
      }
      this.xyShow = false;

      //支付通道 1-微信官方，2-联动，3-鯤鹏
      if (this.appData.payChannel === 3) {
        this.uni.navigateTo(
          "/home/enterMiniProgram?terminalId=" +
            this.terminalId +
            "&deviceMoney=" +
            this.depositAmount +
            "&sn=" +
            this.sn +
            "&isenterAuth=1"+"&phone="+this.phone
        );
      } else {
        const loadingToast = Toast.loading({
          message: "下单中...",
          forbidClick: true,
          duration: 0,
        });

        createDepositOrder({
          terminalId: this.terminalId,
          payMode: "Wechat",
          type: "1",
          phone:this.phone
        }).then((res) => {
          //h5环境
          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                this.onBridgeReady(res, loadingToast),
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent(
                "WeixinJSBridgeReady",
                this.onBridgeReady(res, loadingToast)
              );
              document.attachEvent(
                "onWeixinJSBridgeReady",
                this.onBridgeReady(res, loadingToast)
              );
            }
          } else {
            this.onBridgeReady(res, loadingToast);
          }
        });
      }
    },

    ///支付
    onBridgeReady(res, loadingToast) {
      let result = JSON.parse(res);
      let that = this;

      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: result.appId,
          timeStamp: result.timeStamp.toString(),
          nonceStr: result.nonceStr,
          package: result.package,
          signType: result.signType,
          paySign: result.paySign,
        },
        function (wxR) {
          loadingToast.clear();
          if (wxR.err_msg == "get_brand_wcpay_request:ok") {
            // 支付成功
            that.$store.dispatch("updateDeviceID", that.terminalId);
            ///跳转至认证页面
            that.uni.navigateTo("/home/auth?sn=" + that.sn + "&isFirst=1");
          } else if (wxR.err_msg == "get_brand_wcpay_request:cancel") {
            // 取消支付
          }
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.recharge-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f5f5f5;
}

.header {
  position: relative;
  width: 100%;
  min-height: 200px;

  .header-bg {
    width: 100%;
    height: auto;
    display: block;
  }

  .header-title {
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    color: #d66522;
    font-size: 64px;
    font-weight: bold;
    z-index: 999;
    white-space: nowrap;
  }
}

.center-title {
  display: block;
  font-size: 32px;
  color: #ab4f17;
  margin: 0px 32px 0 32px;
  padding: 0px 20px;
  background-color: #ffecd4;
  border-radius: 16px;
  white-space: pre-wrap;
  word-break: break-word;
}

.center-tip {
  font-size: 28px;
  color: #999999;
  margin: 0px 32px;
}

.bottom-content {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 100;
}

.payment-content {
  background-color: #f5f5f5;
  padding: 0px 20px 20px 20px;
  .payment-infor {
    font-size: 24px;
    color: #848992;
    margin: 0;
  }
}

.mainC {
  color: #ab4f17;
}

.footer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 68px 60px 68px;

  .payment-button {
    display: flex;
    flex: 1;
    height: 92px;
    border: none;
    color: #ffffff;
    font-size: 36px;
    font-weight: bold;
    background: linear-gradient(325deg, #ff6a1b 0%, #f7cb57 100%);
    border-radius: 200px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
  }
}

.footer-content-2 {
  display: flex;
  padding: 20px 30px 55px 30px;
  align-items: center;
  justify-content: space-between;

  .payment-button-2 {
    width: 270px;
    height: 92px;
    border: none;
    color: #ffffff;
    font-size: 32px;
    font-weight: bold;
    background: linear-gradient(325deg, #ff6a1b 0%, #f7cb57 100%);
    border-radius: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .footer-content-price {
    font-size: 32px;
    color: #333333;
    .price-amount {
      font-weight: bold;
      font-size: 48px;
    }
  }
}

.xy-content {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
  padding: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 32px 32px 0px 32px;
}

// /* 居中标题，屏幕中心 */
.xy-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 32px;
  font-weight: bold;
  color: #24262b;
  text-align: center;
}

/* 右侧内容靠右 */
.xy-right {
  margin-left: auto; /* 推到最右边 */
  // margin-right: 32px;
  display: flex;
  align-items: center;
  font-size: 28px;
  font-weight: normal;
  color: #fd8d32;

  .xy-icon {
    width: 32px;
    height: 32px;
    margin-right: 4px; /* 图标和文字间距 */
  }
}

.xy-body {
  flex: 1;
  overflow: auto;
  height: calc(100% - 200px);
}

.xy-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.xy-foot {
  position: sticky;
  display: flex;
  background-color: white;
  display: flex;
  justify-content: space-between; /* 两边对齐，中间间隔用 margin */
  margin: 20px;
}

.xy-cancel,
.xy-ok {
  flex: 1;
  text-align: center;
  padding: 24px 0;
  border-radius: 16px;
  cursor: pointer;
  background-color: #f5f6fa;
  color: #999999;
  margin-bottom: 20px;
}

.xy-ok {
  margin-left: 26px; /* 间隔的一半 */
  background-color: #fd8d32;
  color: #ffffff;
}

.xy-ok.disabled {
  color: #999;
  cursor: not-allowed;
  background-color: #f5f6fa;
}
</style>
